
import { useIntl } from 'react-intl'
import { PageLink, PageTitle } from '../../../_theme/layout/core'
import { Content } from '../../../_theme/layout/components/Content'
import { ManageProjectToolbar } from '../../../_theme/layout/components/toolbar/ManageProjectToolbar'
import { MyProjects } from '../../modules/project/MyProjects'
import { decodeBase64, envConfig, getDashboardLink } from '../../../utils/config'


const ProjectPage = () => {
    const { dashboard, url } = Object.fromEntries(new URLSearchParams(window.location.search));
    const intl = useIntl();

   
    const breadCrumbs: Array<PageLink> = [
        {
            title: 'Dashboard',
            path: getDashboardLink(),
            isSeparator: false,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        },
        dashboard && url
            ? {
                title: decodeBase64(dashboard),
                path: `/${decodeBase64(url)}`,
                isSeparator: false,
                isActive: false,
            }
            : null,
        dashboard && url ? {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        } : null,
        {
            title: 'Projects',
            path: '',
            isSeparator: false,
            isActive: false,
        },
    ].filter(Boolean) as PageLink[];

    return (
        <>
            <PageTitle sitetitle={envConfig.APP_GOV_TITLE} breadcrumbs={breadCrumbs}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle>
            <ManageProjectToolbar customPadding='py-5 px-3' />
            <Content>
                <MyProjects />
            </Content>
        </>
    )
}

export { ProjectPage }
